export const DEFAULT_TIMEOUT = 30000;
export const DEFAULT_POLL_INTERVAL = 2000;
export const DEFAULT_MAX_POLL_ATTEMPTS = 30;

export const DEFAULT_ENDPOINTS = {
  createSession: "/payments/session",
  verifyPayment: "/payments/verify",
  paymentStatus: "/payments/status",
  cancelPayment: "/payments/cancel"
} as const;
